<div
  class="notification-badge-container"
  (click)="badgeOpen.next('notifications')"
  [ngClass]="{ 'has-notifications': count >= 1 }">
  <button mat-icon-button class="p-n">
    <span class="notifications-number" *ngIf="count >= 1"> {{ count }} </span>
    <i class="material-icons menu-button"> notifications </i>
  </button>
</div>
